import { Component } from '@angular/core';

@Component({
  selector: 'app-agb-view',
  templateUrl: './agb-view.component.html',
  styleUrls: ['./agb-view.component.scss'],
  standalone: false
})
export class AGBViewComponent { }
